<template>
  <div>
    <Head :title="$t('global.update') + ' ' +$t('settings.intervention_types') + ' - ' +correctName" />

    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" href="/interventiontypes">
        {{ $t('settings.intervention_types') }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{ correctName }}
    </h1>
    <trashed-message v-if="data.deleted_at" class="mb-6" @restore="restore">
      {{ $t('interventiontypes.trashed_message') }}
    </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <Form :form-data="form"></Form>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!data.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
                  @click="destroy">{{ $t('global.delete') }}
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ $t('global.update') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Form from './Form'

export default {
  components: {
    Form,
    Head,
    Link,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    data: Object,
    auth: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        'id': this.data.id,
        'name': this.data.name,
        'deleted_at': this.data.deleted_at,
        'empty_field': this.data.empty_field

      }),
    }
  },
  computed: {
    correctName() {
      return this.data.name[this.auth.user.language]
    },
  },
  methods: {
    update() {
      this.form.put(`/interventiontypes/${this.data.id}`)
    },
    destroy() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.delete(`/interventiontypes/${this.data.id}`)
        }
      })
    },
    restore() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.put(`/interventiontypes/${this.data.id}/restore`)
        }
      })
    },
  },
}
</script>
